import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import mapButtonType from "@qlik/qlik/src/components/Cta/mapButtonType";

/**
 * HorizontalCardStack component
 * @param {Object} data - The data for the card stack
 * @returns {JSX.Element} - Rendered component
 */
const HorizontalCardStack = ({ data }) => {
    const { customId, additionalConfiguration, cardItems = [], cta = [] } = data ?? {};
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "pt-7.5 pb-15 lg:pt-10 lg:pb-25");
    const cardWithoutType = (cardCta) => {
        const { type, ...restCtaData } = cardCta || {};
        return restCtaData;
    };
    return (
        <section className={`${sectionPaddingClassName}`} id={customId}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="grid md:grid-cols-4 md:gap-10 xl:gap-x-20">
                            {/* Map through cardItems and render each card */}
                            {cardItems?.map((card) => (
                                <Cta
                                    key={card.id}
                                    className="group/card relative grid
                        max-md:grid-cols-[48px_auto] max-md:gap-x-7.5 max-md:py-7.5 max-md:border-t max-md:border-stone/50
                        hover:no-underline
                        md:row-span-4 md:grid-rows-[subgrid] md:gap-0
                        after:[''] after:absolute after:-inset-7.5 after:-bottom-[23px] after:b-4 after:bg-white after:-z-1 after:rounded after:shadow-lg
                        after:opacity-0 after:transition-opacity after:duration-500 after:ease-in-out xl:hover:after:opacity-100"
                                    data={cardWithoutType(card?.cta?.[0])}
                                >
                                    <div className="w-12 h-12 flex content-center justify-center max-md:row-[1/3] md:mb-7.5">
                                        {/* Render media if it exists */}
                                        {card?.media?.[0] && (
                                            <Media
                                                media={card?.media?.[0]}
                                                className="w-auto h-auto max-w-full max-h-full"
                                            />
                                        )}
                                    </div>
                                    <div className="max-md:col-[2/2] max-md:mb-2.5 md:mb-3.75">
                                        {/* Render title if it exists */}
                                        {card.title && (
                                            <h3
                                                className="title-5"
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML={{
                                                    __html: renderSanitizedHtmlContent(card.title),
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="max-md:col-[2/2] md:mb-6.25">
                                        {/* Render description if it exists */}
                                        {card?.description?.description && <p>{card.description.description}</p>}
                                    </div>
                                    <div className="hidden leading-[0] md:block xl:opacity-0 xl:transition-opacity delay-100 duration-500 ease-in-out xl:group-hover/card:opacity-100">
                                        {/* Render CTA text if it exists */}
                                        {card?.cta?.[0]?.text && (
                                            <span className={mapButtonType(card?.cta?.[0]?.type)}>
                                                {card.cta[0].text}
                                            </span>
                                        )}
                                    </div>
                                </Cta>
                            ))}
                        </div>
                    </div>
                    <div className="col-12 mt-3 md:mt-14">
                        {/* Map through cta and render each button */}
                        {cta?.map((button) => (
                            <Cta key={button.id} data={button} className="mx-auto z-1 w-full md:w-fit" />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
export default HorizontalCardStack;
